import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customDate' })
export class DatePickerPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    let dateString = super.transform(value, args);
    const meridian = dateString?.match(/[0-9]\s?(AM|PM)/);
    if (meridian) {
      dateString = dateString.replace(meridian[1], (meridian[0].includes(' ') ? '' : ' ') + meridian[1].toLowerCase());
    }
    return dateString;
  }
}
